import React, { useState, useEffect, Fragment } from 'react';
import { toast } from 'react-toastify';
import _ from 'lodash';
import TypeOrganismTable from './TypeOrganismTable';
import AddTypeOrganismForm from './AddTypeOrganismForm';
import EditTypeOrganismForm from './EditTypeOrganismForm';
import { getAllTypeOrganism, addTypeOrganism, updateTypeOrganism } from 'services/API/Clients';

import 'assets/styles/index.scss';

import './typeorganism.style.scss';

const TypeOrganismPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [typeOrganism, setTypeOrganism] = useState(null);
  const initialFormState = { id: null, name: '' }

  // Setting state
  const [currentTypeOrganism, setCurrentTypeOrganism] = useState(initialFormState)
  const [editing, setEditing] = useState(false)

  const getTypeOrganism = async () => {
    await getAllTypeOrganism()
      .then((g) => {
        setTypeOrganism(g.data.data);
        setIsLoading(true);
      })
      .catch(() => toast.error("Impossible de charger les types d'organisme"));
  }

  useEffect(() => {
    getTypeOrganism();
  }, []);

  // CRUD operations
  const handleAddTypeOrganism = obj => {
    addTypeOrganism(obj)
      .then(() => {
        getTypeOrganism();
        toast.success(`Types d'organisme ${obj.name} créé`);
      })
      .catch((err) => toast.error(err.response.data['message']));
  }

  const handleUpdateTypeOrganism = (id, obj) => {

    updateTypeOrganism(obj)
      .then(() => {
        getTypeOrganism();
        setEditing(false)
        toast.success(`Types d'organisme  ${obj.name} mise à jour`);
      })
      .catch((err) => toast.error(err.response.data['message']));
  }

  const handleDeleteTypeOrganism = id => {
    setEditing(false)
    setTypeOrganism(typeOrganism.filter(obj => obj.id !== id))
  }
  
  const editRow = obj => {
    setEditing(true)
    setCurrentTypeOrganism({ id: obj.id, name: obj.name })
  }
  return (
    <React.Fragment>
      {isLoading &&
        <div className="container " >
          <div className="div-header pb-4">
            <h1 className="pb-4">Gestion des Types d'organisme </h1>
          </div>
          <div className="div-quotestatus">

            <div >
              {!_.isEmpty(typeOrganism) ? (
                <TypeOrganismTable typeOrganism={typeOrganism} editRow={editRow} handleDeleteTypeOrganism={handleDeleteTypeOrganism} />
              ) : (
                <p className="message">Aucune fonction disponible. Veuillez ajouter des fonctions.</p>
              )}
            </div>

            <div className="main-form">
              {editing ? (
                <Fragment>
                  <h2>Editer un type d'organisme</h2>
                  <EditTypeOrganismForm
                    editing={editing}
                    setEditing={setEditing}
                    currentTypeOrganism={currentTypeOrganism}
                    handleUpdateTypeOrganism={handleUpdateTypeOrganism}
                  />
                </Fragment>
              ) : (
                <Fragment>
                  <h2>Ajouter un type d'organisme</h2>
                  <AddTypeOrganismForm handleAddTypeOrganism={handleAddTypeOrganism} />
                </Fragment>
              )}
            </div>
          </div>
        </div>
      }
    </React.Fragment>
  );
}

export default TypeOrganismPage;

